export default "__VITE_ASSET__36465324__"